import React, { useEffect, useState } from "react";
import { whatsappLink } from "../data/site";
import { WhatsApp } from "./Icons";
import { cx } from "../lib/ui";

/**
 * Appears once the hero is behind you, and stands down again over the
 * footer — which carries its own WhatsApp link and a back-to-top control
 * the button would otherwise sit on top of.
 */
export default function FloatingWhatsApp() {
  const [pastHero, setPastHero] = useState(false);
  const [overFooter, setOverFooter] = useState(false);

  useEffect(() => {
    let frame = 0;
    const measure = () => {
      frame = 0;
      setPastHero(window.scrollY > window.innerHeight * 0.85);
    };
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(measure);
    };
    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  useEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer || typeof IntersectionObserver === "undefined") return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setOverFooter(entry.isIntersecting),
      { rootMargin: "0px 0px -12% 0px", threshold: 0 }
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  const visible = pastHero && !overFooter;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat with Shree Siddhi Realty on WhatsApp"
      className={cx(
        "group fixed bottom-[clamp(16px,3vw,34px)] right-[clamp(16px,3vw,34px)] z-[880]",
        "inline-flex h-[54px] items-center gap-0 rounded-full bg-paper px-4 text-ink",
        /* The hairline keeps the white pill legible on the white sections,
           where the shadow alone was doing all the work. */
        "shadow-[0_12px_34px_rgba(0,0,0,0.42)] ring-1 ring-black/15",
        "transition-[opacity,transform,gap,background-color,color] duration-500 ease-out",
        "hover:gap-2.5 hover:bg-ink hover:text-paper hover:ring-paper",
        visible
          ? "pointer-events-auto translate-y-0 scale-100 opacity-100"
          : "pointer-events-none translate-y-4 scale-95 opacity-0"
      )}
    >
      <WhatsApp width="21" height="21" className="relative z-10" />
      <span className="relative z-10 max-w-0 overflow-hidden whitespace-nowrap text-[11.5px] font-semibold uppercase tracking-[0.18em] transition-[max-width] duration-500 ease-out group-hover:max-w-[130px] group-focus-visible:max-w-[130px]">
        WhatsApp
      </span>
      <span className="pointer-events-none absolute inset-0 animate-pulse-ring rounded-full border border-current opacity-35" />
    </a>
  );
}
